import { Modal } from 'react-bootstrap';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { addCurrentThemeClassToEle } from '@/utils';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import LightGrayCross from "@/assets/icons/lightGrayCross.png";
import "./style.css"
import { themes } from '@/constants/colors_v2';

function ExamReAttemptModal(props: any) {
    const { dashboard, common } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose('close')} centered>
            <div className={`p-[20px] ${addCurrentThemeClassToEle(currentTheme, 'examReAttemptModalIndex')}`}>

                <Modal.Header className='p-0 border-0 mb-[10px]'>


                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.title}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.title}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}
                    {/* <Modal.Title className='text-[16px] font-bold'>
                        {props.title}
                    </Modal.Title>
                    <button
                        onClick={() => props.handleClose('close')}
                        type="button"
                        className="btn-close text-[14px]" aria-label="Close"></button> */}


                </Modal.Header>

                <Modal.Body className='p-0'>
                    {props.examAttempts < 2 ? (
                        <div className="text-[14px] space-y-4">
                            <p>{dashboard.evaluateSection.exam.reAttemptModal.one}</p>
                            <ol className="list-decimal pl-5 space-y-2">
                                <li>
                                    {dashboard.evaluateSection.exam.reAttemptModal.two}{' '}
                                    <strong>
                                        {props.examAttempts === 2 && dashboard.evaluateSection.exam.reAttemptModal.three_one}
                                        {props.examAttempts === 1 && dashboard.evaluateSection.exam.reAttemptModal.three_two}
                                    </strong>
                                    {' '}{dashboard.evaluateSection.exam.reAttemptModal.four}
                                </li>
                                <li>{dashboard.evaluateSection.exam.reAttemptModal.five}</li>
                            </ol>
                            <p>
                                {dashboard.evaluateSection.exam.reAttemptModal.six}
                                {' '}<strong>"{dashboard.evaluateSection.exam.reAttemptModal.seven}"</strong>{' '}
                                {dashboard.evaluateSection.exam.reAttemptModal.eight}
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className='text-[14px]'>
                                <p className='mb-[10px]'>{dashboard.evaluateSection.exam.reAttemptModal.nine}</p>
                                <p>{dashboard.evaluateSection.exam.reAttemptModal.ten}
                                    <strong>{' '}{dashboard.evaluateSection.exam.reAttemptModal.eleven}</strong>
                                </p>

                            </div>
                        </>
                    )}
                </Modal.Body>


                <div className="text-[14px] flex justify-between mt-6 space-x-4">
                    <button
                        disabled={props.actionBtnLoading}
                        style={{
                            cursor: props.actionBtnLoading ? 'not-allowed' : 'pointer',
                            opacity: props.actionBtnLoading ? '0.4' : '1'
                        }}
                        className="watchModel12LeftBtn flex-1 font-medium py-2 rounded-md"
                        onClick={() => props.handleClose('ok')}
                    >
                        {props.examAttempts < 2 ? dashboard.evaluateSection.exam.okBtn : dashboard.evaluateSection.exam.payBtn}
                    </button>
                    <button
                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-md"
                        onClick={() => props.handleClose('close')}
                    >
                        {common.statusText.cancleBtn}
                    </button>
                </div>

            </div>
        </Modal>
    );
}

export default ExamReAttemptModal;